import { Icon, Table } from "@scuf/common";
import { useTranslation } from 'react-i18next';
import "styles/main.scss";

export interface ManualFile {
    id: number;
    displayName: string;
    storedFileName: string;
    section: string;
    ssoId?: string;
    language?: string | null;
}

interface FilesTableProps {
    title: string;
    files: ManualFile[];
    isEditable: boolean;
    downloadingId: number | null;
    deletingId: number | null;
    onDownload: (file: ManualFile) => void;
    onDelete: (id: number) => void;
}

const FilesTable = ({
    title,
    files,
    isEditable,
    downloadingId,
    deletingId,
    onDownload,
    onDelete
}: FilesTableProps) => {
    const { t } = useTranslation();
    if (!files.length) {
        return null;
    }

    return (
        <div className="files-table">
            <Table>
                <Table.Header>
                    <Table.HeaderCell content={title} />
                    <Table.HeaderCell content={t("manual.languages")} />
                    <Table.HeaderCell content={t("manual.options")} />
                </Table.Header>

                <Table.Body>
                    {files.map(file => (
                        <Table.Row key={file.id}>
                            <Table.Cell content={file.displayName} />
                            <Table.Cell>
                                <div className="files-table__languages">
                                    {file.language?.includes("PT") ? <img src="/assets/icons/pt-br.png" alt="PT/BR" width={28} /> : null}
                                    {file.language?.includes("ES") ? <img src="/assets/icons/es-mx.png" alt="ES" width={28} /> : null}
                                    {file.language?.includes("EN") ? <img src="/assets/icons/en-us.png" alt="EN/US" width={28} /> : null}
                                </div>
                            </Table.Cell>
                            <Table.Cell>
                                <div className="files-table__options">
                                    {downloadingId === file.id ? (
                                        <Icon
                                            name="refresh"
                                            loading
                                            exactSize={25}
                                        />
                                    ) : (
                                        <Icon
                                            name="file-download"
                                            exactSize={25}
                                            color="gray"
                                            onClick={() => onDownload(file)}
                                        />
                                    )}

                                    {isEditable && (
                                        deletingId === file.id ? (
                                            <Icon
                                                name="refresh"
                                                loading
                                                exactSize={25}
                                            />
                                        ) : (
                                            <Icon
                                                name="delete"
                                                exactSize={25}
                                                color="gray"
                                                onClick={() => onDelete(file.id)}
                                            />
                                        )
                                    )}
                                </div>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </div>
    );
};

export default FilesTable;